/**
 * Skeleton Loading Component for Related Items
 * Shows skeleton cards in a 3-column grid while loading
 */

import React from 'react';

/**
 * Single skeleton card
 */
function SkeletonCard() {
  return (
    <div 
      className="w-full aspect-square rounded-2xl overflow-hidden bg-gray-100 animate-pulse"
      style={{
        borderRadius: '16px',
      }}
    >
      <div className="w-full h-full bg-gradient-to-br from-gray-200 via-gray-100 to-gray-200" />
    </div>
  );
}

/**
 * Related Items Skeleton Grid
 * @param {Object} props
 * @param {number} props.count - Number of skeleton cards to show (default: 6)
 */
export default function RelatedItemSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-3 gap-3">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={`skeleton-${index}`} />
      ))}
    </div>
  );
}


